import { create } from "zustand";

const useAuthStore = create((set) => ({
  userDB: null,
  setUserDB: (userDB) => set({ userDB }),
  clearUserDB: () => set({ userDB: null }),
}));

export default useAuthStore;
